import {memo} from 'react'

import {Skeleton, type SkeletonProps} from './Skeleton'

export const RectangularSkeleton = memo(function RectangularSkeleton(props: SkeletonProps) {
  return <Skeleton variant="rounded" {...props}/>
})
